import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import TriggerResolution from './TriggerResolution';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyTriggerResolution } from './companyTriggerApi';

/** Company Trigger Trace → Resolution. */
const CTriggerResolution = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyTriggerResolution(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trigger Trace — Resolution | Shoorah</title>
      </Helmet>
      <TriggerResolution fetcher={fetcher} />
    </div>
  );
};

export default CTriggerResolution;
